import { render } from "./CertifiedModal.vue?vue&type=template&id=3ae58936&scoped=true"
import script from "./CertifiedModal.vue?vue&type=script&lang=js"
export * from "./CertifiedModal.vue?vue&type=script&lang=js"

import "./CertifiedModal.vue?vue&type=style&index=0&id=3ae58936&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae58936"]])

export default __exports__